<div nimbusDropFile class="chat-widget-root" [isDropFileDisabled]="!isDragAndDropSupported" (filesDropped)="onFilesDropped($event)">
  <nimbus-chat-messages
    class="full"
    [messages]="messages"
    [chatType]="chatType"
    [taskState]="taskState"
    [emptyTemplate]="emptyTemplate"
    [authorInfoTemplate]="authorInfoTemplate"
    [messageExtensionTemplate]="messageExtensionTemplate"
    [messageActionTemplate]="messageActionTemplate"
    [showActions]="showActions"
    [hideAuthorTime]="hideAuthorTime"
    [hasMoreMessages]="hasMoreMessages"
    (copyTextInitialized)="onCopyTextInitialized($event)"
    (messageSent)="onMessageSent($event)"
    (loadPrevMessagesRequested)="onLoadPrevMessagesRequested()"
  ></nimbus-chat-messages>

  @if (!hideInput) {
    @if (showParkedBanner) {
      <div class="parked-banner">
        <span class="parked-banner-info">
          <i [nimbusIcon]="ICONS.PARK_ROUND" [iconWeight]="IconWeight.Regular"></i>
          <span>{{ TranslationKeys.MySessionsChatParkedBannerText | translate }}</span>
        </span>
        <button nimbusPrimaryButton class="parked-banner-unpark" [disabled]="unparkDisabled" (click)="onUnpark()">
          <i [nimbusIcon]="ICONS.UNPARK_ROUND" [iconWeight]="IconWeight.Regular"></i>
          <span>{{ TranslationKeys.ConversationUnpark | translate }}</span>
          <nimbus-tooltip [text]="unparkTooltip | translate"></nimbus-tooltip>
        </button>
      </div>
    }

    <div class="chat-widget-composer">
      @if (warningMessage; as message) {
        <nimbus-info-banner variant="warning">{{ message | translate }}</nimbus-info-banner>
      }

      <nimbus-chat-input-message
        [taskState]="taskState"
        [chatType]="chatType"
        [isDisabled]="isDisabled"
        [saveDraftApiUrl]="saveDraftApiUrl"
        [conversationId]="conversationId"
        [enableDraft]="enableDraft"
        [isMediaHandlingEnabled]="isMediaHandlingEnabled"
        [mediaPolicy]="mediaPolicy"
        [isCustomerChat]="isCustomerChat"
        [showStopButton]="showStopButton"
        (messageSent)="onMessageSent($event)"
        (attachmentsSent)="onAttachmentsSent($event)"
        (voiceMessageSent)="onVoiceMessageSent($event)"
        (stopRequested)="onStopRequested()"
      ></nimbus-chat-input-message>
    </div>
  }

  <div class="chat-widget-drop-overlay"></div>
</div>
